import { Entity, Column, PrimaryGeneratedColumn, ManyToOne, JoinColumn, OneToOne } from 'typeorm'

import Question from './Question'
import OptionsConfiguration from '../testConfigurations/OptionConfiguration'
import { QuestionOptionQualificationImpact } from '../entityTypes'

@Entity('question_options')
export default class QuestionOption {
  @PrimaryGeneratedColumn()
  id!: number

  @ManyToOne(type => Question, question => question)
  @JoinColumn({ name: 'question_id' })
  question!: Question

  @Column()
  text!: string

  @Column({ name: 'image' })
  image?: string

  @Column()
  order!: number

  @Column({ type: 'text', array: true, name: 'qualification_tags' })
  qualificationTags!: string[]

  @Column()
  shuffle!: boolean

  @Column({ name: 'is_terminating' })
  isTerminating!: boolean

  // need more info, deals with completes
  @Column({ name: 'is_correct_option' })
  isCorrectOption!: boolean

  @Column({ name: 'variance_tag' })
  varianceTag?: string

  @Column({ name: 'label' })
  label?: string

  @Column({ name: 'link' })
  link?: string

  @OneToOne(type => OptionsConfiguration, optionConfiguration => optionConfiguration.option)
  configuration?: OptionsConfiguration

  @Column({
    name: 'qualification_impact',
    nullable: true,
    default: null
  })
  qualificationImpact!: QuestionOptionQualificationImpact
}
